import styled from '@emotion/styled';
import { Stack, Typography, colors } from '@ui-components/neo.tax';
import { Link } from 'react-router-dom';

export const StyledAuthHero = styled(Stack)({
  padding: '1.5rem 0',
  gap: '0.5rem',
});

export const StyledAuthSubtitle = styled(Typography)({
  color: colors.gray[600],
});

export const StyledAuthSwitch = styled(Link)({
  color: colors.primary[600],
  '&:hover': {
    color: colors.primary[500],
  },
});

export const StyledEnterpriseSsoSwitch = styled(Link)({
  color: colors.gray[800],
  '&:hover': {
    color: colors.gray[700],
  },
  padding: '1.5rem 0 0 0',
  textAlign: 'center',
  textDecoration: 'underline',
  fontSize: '0.875rem',
});
